import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MigrationError } from '@nerdwallet/structured-content-core/migrations';
import { WPPOSTLIST } from '../../../types'; // migration follows refactor of WpPostList to request data from query0 instead of wp api directly

export default function migrateWpPostListFrom_1_0_0_to_2_0_0(_ref) {
  var type = _ref.type,
      version = _ref.version,
      props = _ref.props;
  if (version !== '1.0.0') throw new MigrationError("".concat(WPPOSTLIST, " v2.0.0 migrator should only operate on ").concat(WPPOSTLIST, " v1.0.0 nodes, got: v").concat(version)); // eslint-disable-line prettier/prettier

  var _props$query = props.query,
      categories = _props$query.categories,
      include = _props$query.include,
      per_page = _props$query.per_page,
      post_types = _props$query.post_types,
      author = _props$query.author; // convert prop names and values from wp-api-service vocabulary to query0 schema vocabulary

  var query = {
    authorIds: author,
    categoryIdentifiers: categories,
    // convert post_types to PostTypeEnum values (query0 type)
    contentTypes: post_types === null || post_types === void 0 ? void 0 : post_types.map(function (postType) {
      return postType.replace('nw_', '').replace(/-/g, '_').toUpperCase();
    }),
    include: include,
    perPage: per_page
  };
  return {
    type: type,
    version: '2.0.0',
    props: _objectSpread(_objectSpread({}, props), {}, {
      query: query
    })
  };
}